import { styled, Box, Flex, StyleSystemProps, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

const DEFAULT_IMAGE = 'https://withjoy.com/assets/public/apps/registry/custom-item-default.svg';

const productPhotoStyles: StyleSystemProps = {
  width: '100%',
  height: '100%',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  transition: 'transform 0.25s',
  justifyContent: 'center',
  display: 'flex',
  position: 'absolute',
  top: 0,
  _after: {
    display: 'block',
    position: 'absolute',
    borderRadius: pxToRem(4),
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    transform: 'scale(1.0001)',
    transition: 'all 0.2s',
    content: `' '`,
  },
};

export const StyledProductPhoto = styled(Box)<{ photoUrl?: string; $isCompleted?: boolean }>`
  mix-blend-mode: multiply;
  ::after {
    ${({ $isCompleted, photoUrl }) => {
      return {
        backgroundImage: `url("${photoUrl || DEFAULT_IMAGE}")`,
        backgroundSize: photoUrl ? 'contain' : '50%',
        opacity: $isCompleted ? 0.4 : 1,
      };
    }}
  }
`;

export const StyledProductTile = styled(Box)<{ canClick: boolean }>`
  contain: content;
  cursor: ${({ canClick }) => (canClick ? 'pointer' : 'default')};
`;

export const ProductTileContainer = styled(Flex)``;

const productPhotoWrapperStyles: StyleSystemProps = {
  overflow: 'hidden',
  borderRadius: '8px',
  position: 'relative',
  width: '100%',
  paddingTop: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: pxToRem(12),
};

export const StyledProductPhotoWrapper = styled(Flex)``;

const ProductTitleTextStyles: StyleSystemProps = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const StyledMustHaveWrapper = styled(Flex)``;
const MustHaveWrapperStyles: StyleSystemProps = {
  backgroundColor: 'mono2',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: `${pxToRem(24)}`,
  paddingX: 3,
  paddingY: 1,
};

export const styles = {
  productPhoto: productPhotoStyles,
  productPhotoWrapper: productPhotoWrapperStyles,
  productTitleText: ProductTitleTextStyles,
  mustHaveWrapper: MustHaveWrapperStyles,
};

export const ProductTitleWrapper = styled(Box)`
  padding: 0px 8px;
  margin-bottom: ${pxToRem(4)};
`;

export const StyledTileWrapper = styled(Flex)<{ canClick: boolean }>`
  background-color: white;
  border-radius: 12px;
  padding: ${pxToRem(16)};
  padding-bottom: ${pxToRem(60)};
  will-change: transform;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  border: 1px solid transparent;

  ${({ canClick }) =>
    canClick &&
    `
    &:hover {
      box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.15), 0px 3px 10px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.08);
      transform: translateY(-4px);
      z-index: 10;
      border-color: rgba(0, 0, 0, 0.08);

      ${StyledProductPhoto}::after {
        transform: scale(1.05);
        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      }
    }
  `}
`;

export const ProductSubTitleWrapper = styled(ProductTitleWrapper)`
  -webkit-line-clamp: 1;
`;

export const StyledProductTitleText = styled(TextV2)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: ${pxToRem(44)};
`;
